module.exports = __webpack_public_path__ + "img/awards_image_04.82304fd0.jpg";